import { useEffect, useState } from 'react';
import TitleBar from '@/atoms/TitleBar/TitleBar';
import classNames from 'classnames';

import './AllTemplates.scss';
import TemplateCard from '@/atoms/TemplateCard/TemplateCard';

const AllTemplates: React.FC = () => {
	const templateTypes = ['Hair Do', 'Beard', 'EyeWear', 'Accessories'];
	const [selectedChip, setSelectedChip] = useState(0);

	window.onload = () => {
		resizeAllGridItems();
	};

	const templates = [
		{
			imageUrl: '/static/img/templates/5.png',
			title: 'Heading',
			subtitle: 'Some placeholder texgt goes here aaaaaaaaaaaaaaaaaaa',
		},
		{
			imageUrl: '/static/img/templates/1.png',
		},
		{
			imageUrl: '/static/img/templates/0.png',
			title: 'Heading 3',
		},
		{
			imageUrl: '/static/img/templates/3.png',
			title: 'Heading 2',
			subtitle: 'Lorem ipsum dolar set amet',
		},
		{
			imageUrl: '/static/img/templates/0.png',
			title: 'Heading 3',
		},
		{
			imageUrl: '/static/img/templates/5.png',
			title: 'Heading',
			subtitle: 'Some placeholder texgt goes here aaaaaaaaaaaaaaaaaaa',
		},

		{
			imageUrl: '/static/img/templates/1.png',
		},
		{
			imageUrl: '/static/img/templates/3.png',
			title: 'Heading 2',
		},
	];
	useEffect(() => {
		resizeAllGridItems();
		// window.addEventListener('resize', resizeAllGridItems);
	}, []);
	return (
		<div>
			<TitleBar title='Templates' />
			<div className='allTemplates-body'>
				<div className='templateChipsRow'>
					{templateTypes.map((templateType, index) => (
						<div
							className={classNames({
								templateChip: true,
								activeChip: index === selectedChip,
							})}
							onClick={() => setSelectedChip(index)}
						>
							{templateType}
						</div>
					))}
				</div>
				<div
					// ${
					//     templates.length / 2
					// },auto
					className='templatesList grid'
					style={{
						gridTemplateColumns: `repeat(auto-fill, minmax(40vw,1fr))`,
					}}
				>
					{templates.map(template => (
						<TemplateCard {...template} />
					))}
				</div>
			</div>
		</div>
	);
};

export default AllTemplates;

function resizeGridItem(item: any) {
	const grid = document.getElementsByClassName('grid')[0];
	const rowHeight = parseInt(
		window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'),
	);
	console.log(rowHeight);
	console.log(item.querySelector('.content').getBoundingClientRect().height);
	const rowSpan = Math.ceil(
		item.querySelector('.content').getBoundingClientRect().height /
			rowHeight,
	);
	console.log(rowSpan);
	item.style.gridRowEnd = 'span ' + rowSpan;
}

function resizeAllGridItems() {
	const allItems = document.getElementsByClassName('template-card');
	for (let x = 0; x < allItems.length; x++) {
		resizeGridItem(allItems[x]);
	}
}
